module.exports = __webpack_public_path__ + "img/ai_recycle_03.00aa8e51.png";